import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const ReadyContext = createContext();

export const ReadyProvider = ({ children, onAllReady }) => {
  const [readyCount, setReadyCount] = useState(0);
  const [totalComponents, setTotalComponents] = useState(-1);
  const [componentsReady, setComponentsReady] = useState(false);
  const [initialEditorData, setInitialEditorData] = useState({
    item: null,
    passage: null,
  });

  useEffect(() => {
    if (
      !componentsReady &&
      totalComponents !== -1 &&
      readyCount >= totalComponents
    ) {
      setComponentsReady(true);
      onAllReady?.();
    }
  }, [readyCount, totalComponents, componentsReady, onAllReady]);

  const markReady = useCallback(
    (items, componentType) => {
      setReadyCount((prev) => {
        return prev + 1;
      });

      if (
        isValidEmptyArray(items) &&
        componentType &&
        (componentType === READY_COMPONENT_TYPE.ITEM ||
          componentType === READY_COMPONENT_TYPE.PASSAGE)
      ) {
        setReadyComponentsWithEmptyArray();
      }

      if (totalComponents === -1) {
        if (
          componentType &&
          componentType === READY_COMPONENT_TYPE.ITEM &&
          items
        ) {
          calculateItemTotal(items);
        } else if (
          componentType &&
          componentType === READY_COMPONENT_TYPE.PASSAGE &&
          items
        ) {
          calculatePassageTotal();
        }
      }
    },
    [totalComponents],
  );

  const isValidEmptyArray = (value) => {
    return Array.isArray(value) && value.length === 0;
  };

  const areComponentsReady = useCallback(() => {
    return componentsReady;
  }, [componentsReady]);

  const getInitialEditorData = () => initialEditorData;

  const insertInitialEditorData = useCallback((inputData) => {
    setInitialEditorData(inputData);
  }, []);

  const calculateItemTotal = (items) => {
    return items.map((item) => {
      const foilCount =
        item.interactions?.reduce((sum, interaction) => {
          return sum + (interaction.foils?.length || 0);
        }, 0) || 0;

      const total = 1 + foilCount;

      setTotalComponents(total);
    });
  };

  const calculatePassageTotal = () => {
    setTotalComponents(2);
  };

  const setReadyComponentsWithEmptyArray = () => {
    setTotalComponents(0);
    setComponentsReady(true);
    onAllReady?.();
  };

  return (
    <ReadyContext.Provider
      value={{
        markReady,
        areComponentsReady,
        getInitialEditorData,
        insertInitialEditorData,
      }}
    >
      {children}
    </ReadyContext.Provider>
  );
};

export const useReadyContext = () => {
  const context = useContext(ReadyContext);
  if (!context) {
    throw new Error("useReadyContext must be used within a ReadyProvider");
  }
  return context;
};

export const READY_COMPONENT_TYPE = {
  ITEM: "ITEM",
  PASSAGE: "PASSAGE",
};
